module.exports = __webpack_public_path__ + "img/State=20.f6740abe.svg";